import { render, staticRenderFns } from "./MyHelp.vue?vue&type=template&id=67cedf8a&scoped=true"
import script from "./MyHelp.vue?vue&type=script&lang=js"
export * from "./MyHelp.vue?vue&type=script&lang=js"
import style0 from "./MyHelp.vue?vue&type=style&index=0&id=67cedf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cedf8a",
  null
  
)

export default component.exports